<script setup lang="ts">
import { useSessionTimeoutStore } from "../stores/sessionTimeout";
import { useConfigStore } from "@/stores/config";
import { computed, ComputedRef } from "vue";

const sessionTimeoutStore = useSessionTimeoutStore();
const configStore = useConfigStore();

defineProps<{
    timeLeft: ComputedRef<string>,
}>();

function StillHere() {
    sessionTimeoutStore.endTime = Date.now() + configStore.sessionTimeoutPage;
    sessionTimeoutStore.touchSession();
}

const modalClass = computed(() => {
    return sessionTimeoutStore.shouldShowTimeoutWarning()
        ? "modal-show"
        : "modal";
});
</script>

<template>
    <div
        id="timeout-warning"
        :class="modalClass"
    >
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">
                        Session about to time out
                    </h5>
                    <button
                        type="button"
                        class="btn-close"
                        aria-label="Close"
                        @click="StillHere"
                    />
                </div>
                <div class="modal-body">
                    <p>
                        As you have been inactive for a while, your session will
                        time out in: {{ timeLeft }}.
                    </p>
                </div>
                <div class="modal-footer">
                    <button
                        type="button"
                        class="btn btn-primary"
                        @click="StillHere"
                    >
                        I'm still here
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.modal-show {
    position: fixed;
    margin-top: 20%;
    top: 0;
    left: 0;
    z-index: 1060;
    display: block;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    outline: 0;
}
</style>
